<template>
  <div class="flex gap-3 flex-wrap">
    <a
      target="_blank"
      :href="socialLinks[lang]?.google || socialLinks.default.google"
    >
      <Button fillOnHover border :color="'#4285F4'">
        <box-icon type="logo" name="google" color="inherit"></box-icon>
      </Button>
    </a>
    <a
      target="_blank"
      :href="socialLinks[lang]?.facebook || socialLinks.default.facebook"
    >
      <Button fillOnHover border :color="'#3b5998'">
        <box-icon type="logo" name="facebook"></box-icon>
      </Button>
    </a>
    <a
      target="_blank"
      :href="socialLinks[lang]?.twitter || socialLinks.default.twitter"
    >
      <Button fillOnHover border :color="'#1DA1F2'">
        <box-icon type="logo" name="twitter"></box-icon>
      </Button>
    </a>
    <a
      target="_blank"
      :href="socialLinks[lang]?.pinterest || socialLinks.default.pinterest"
    >
      <Button fillOnHover border :color="'#E60023'">
        <box-icon type="logo" name="pinterest"></box-icon>
      </Button>
    </a>
    <a
      target="_blank"
      :href="socialLinks[lang]?.linkedin || socialLinks.default.linkedin"
    >
      <Button fillOnHover border :color="'#0077b5'">
        <box-icon type="logo" name="linkedin"></box-icon>
      </Button>
    </a>
    <a
      target="_blank"
      :href="socialLinks[lang]?.instagram || socialLinks.default.instagram"
    >
      <Button fillOnHover border :color="'#C13584'">
        <box-icon type="logo" name="instagram"></box-icon>
      </Button>
    </a>
  </div>
</template>

<script>
import Button from "./Button.vue";
import socials from "@/helpers/socialLinks.json";

export default {
  name: "Socials",
  props: {
    lang: String,
  },
  computed: {
    socialLinks() {
      return socials;
    },
  },
  components: { Button },
};
</script>

<style></style>
